<!-- 认款结算 -->
<template>
    <div class='page_content'>
        <div class="content">
            <el-card class="box-card" style="margin-right: 10px;">
                <div slot="header" class="clearfix ">
                    <v-search :searchList="pageShowData.jurFormVoList.filter(item => item.jciId == 1078082)[0].jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                    </v-search>
                </div>
                <div style="height: 33.33px;"></div>
                <el-table class="table1" stripe :data="tableData" :height="tableHeight" border style="width: 100%" highlight-current-row size="mini">
                    <el-table-column label="选择操作" width="80">
                        <template slot-scope="scope">
                            <el-radio v-model="leftSelectIndex" :label="scope.row.index" border size="mini">
                                <i class="el-icon-thumb"></i>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <template v-for="(tableValye, tableKey) in pageShowData.jurFormVoList.filter(item => item.jciId == 1078083)[0].jurconfigform">
                        <el-table-column align="center" v-if="tableValye.isShow == 1" :sortable="tableValye.fieldType == 'date' ? true : false" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                         :prop="tableValye.entityField" :label="tableValye.showField">
                            <template slot-scope="scope">
                                <!-- <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span> -->
                                <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                                <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                </span>
                                <el-input v-else-if="tableValye.isChange == 1" clearable v-model="scope.row[tableValye.entityField]" :ref="tableValye.entityField" :id="tableValye.entityField"
                                          :disabled="tableValye.isChange == 0">
                                </el-input>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                    {{ scope.row.isWms == 0 ? '否' : '是' }}
                                </el-tag>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                                </span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">{{ $common.getIsGsp(tableValye.formatterContent, scope.row.woamState) }}</el-tag>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <div class="bottom"><v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                </div>
            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <v-search :searchList="pageShowData.jurFormVoList.filter(item => item.jciId == 1078084)[0].jurconfigform" :getRequestData="getRequestData1" @searchData="searchData1" @openSearch="openSearch"
                              :showMx="true" @saveData="saveData" :totalInfo="totalInfo">

                    </v-search>

                </div>
                <div style="display: flex; justify-content: space-between">
                    <el-radio-group v-model="totalInfo.selRadio">
                        <el-radio-button label="付款"></el-radio-button>
                        <el-radio-button label="货款"></el-radio-button>
                    </el-radio-group>
                    <div>

                        <span style="font-size: 20px;">退款金额: <span>{{ totalInfo.settleMoney }}</span></span> <span style="margin-left: 10px;font-size: 20px;">结算总金额: <span>{{ totalInfo.totalMoney }}</span></span>
                    </div>

                </div>
                <el-table v-if="totalInfo.selRadio =='货款'" @selection-change="changeChoice" :row-style="rowStyle" class="table1" ref="tableData2" :data="tableData1" :height="tableHeight1" border style="width: 100%"
                          size="mini">
                    <el-table-column type="selection" width="40"></el-table-column>
                    <template v-for="(tableValye, tableKey) in pageShowData.jurFormVoList.filter(item => item.jciId == 1078085)[0].jurconfigform">
                        <el-table-column align="center" v-if="tableValye.isShow == 1" :sortable="tableValye.fieldType == 'date' ? true : false" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                         :prop="tableValye.entityField" :label="tableValye.showField">
                            <template slot-scope="scope">
                                <!-- <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span> -->
                                <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                                <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                </span>
                                <span v-else-if="tableValye.entityField == 'businessId'" style="color: blue;cursor: pointer;" @click="seedetail(scope.row.businessId)">
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                                <el-input @mousewheel.native.prevent v-else-if="tableValye.entityField == 'settleMoney'" @input="settleMoneyJudge1(scope.row,scope.row.index)" v-model="scope.row.settleMoney"
                                          :ref="tableValye.entityField" :id="tableValye.entityField" :disabled="tableValye.isChange == 0">
                                </el-input>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                    {{ scope.row.isWms == 0 ? '否' : '是' }}
                                </el-tag>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                                </span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">{{ $common.getIsGsp(tableValye.formatterContent, scope.row.woamState) }}</el-tag>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <el-table v-if="totalInfo.selRadio == '付款'" @selection-change="changeChoice" :row-style="rowStyle" class="table1" ref="tableData1" :data="tableData1" :height="tableHeight1" border style="width: 100%"
                          size="mini">
                    <el-table-column type="selection" width="40"></el-table-column>
                    <template v-for="(tableValye, tableKey) in pageShowData.jurFormVoList.filter(item => item.jciId == 1078087)[0].jurconfigform">
                        <el-table-column align="center" v-if="tableValye.isShow == 1" :sortable="tableValye.fieldType == 'date' ? true : false" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                         :prop="tableValye.entityField" :label="tableValye.showField">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </span>
                                <span v-else-if="tableValye.entityField == 'businessId'" style="color: blue;cursor: pointer;" @click="seedetail(scope.row.businessId)">
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                                <el-input @mousewheel.native.prevent v-else-if="tableValye.entityField == 'settleMoney'" type="number" @input="settleMoneyJudge(scope.row,scope.row.index)" v-model="scope.row.settleMoney"
                                          :ref="tableValye.entityField" :id="tableValye.entityField" :disabled="tableValye.isChange == 0">
                                </el-input>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                    {{ scope.row.isWms == 0 ? '否' : '是' }}
                                </el-tag>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                                </span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">{{ $common.getIsGsp(tableValye.formatterContent, scope.row.woamState) }}</el-tag>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <div class="bottom"><v-pagination :page="getRequestData1.page" :rows="getRequestData1.rows" :total="total1" @setDataPageSize="setDataPageSize1" @setDataPageNumber="setDataPageNumber1"></v-pagination>
                </div>
            </el-card>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="showDetail" :visible.sync="showDetail" width="70%">
            <el-table class="table1" stripe :data="detailData" :height="tableHeight" border style="width: 100%" highlight-current-row size="mini">
                <template v-for="(tableValye, tableKey) in pageShowData.jurFormVoList.filter(item => item.jciId == 1078086)[0].jurconfigform">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                {{ scope.row.isWms == 0 ? '否' : '是' }}
                            </el-tag>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">{{ $common.getIsGsp(tableValye.formatterContent, scope.row.woamState) }}</el-tag>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import ExtractionScheme from "../../../byComponents/ExtractionScheme.vue";
import NP from "number-precision";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
    },
    data() {
        //这里存放数据
        return {
            showTable: false,
            detailData: [],
            showDetail: false,
            seTitle: "",
            DialogVisible: false,
            seWidth: 0,
            parentSearchData: {},
            tableData: [],
            formInline: {},
            tableData1: [],
            formInline1: {},
            leftSelectIndex: 0,
            tableHeight: 0,
            tableHeight1: 0,
            total: 0,
            total1: 0,
            pageShowData: {},
            getRequestData: {

                page: 1,
                rows: 30,
                smName: "",
                smId: "",
                coName: "",
                coId: "",
                start: "",
                end: '',
            },
            getRequestData1: {

                page: 1,
                rows: 30,
                start: "",
                end: '',
                smId: "",
                smName: "",
                coName: "",
                coId: "",
            },
            totalInfo: {
                totalMoney: 0,
                settleMoney: 0,
                selRadio: '付款'
            },
            multipleSelection: [],
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        leftSelectIndex: {
            handler: function () {
                //  this.$nextTick(() => {

                this.totalInfo.settleMoney =
                    this.tableData[this.leftSelectIndex].unsettlement || 0
                this.searchData1();
                //  })
            },
        },
        tableData1: {
            handler: function (nvl, ovl) {
                nvl.forEach((item) => {
                    if (item.settleMoney > 0) {
                        console.log(item, "********")
                        if (this.totalInfo.selRadio == "付款") {
                            console.log(item, "付款")
                            this.$refs.tableData1.toggleRowSelection(item, true)
                        } else if (this.totalInfo.selRadio == "货款") {
                            console.log(item, "货款")
                            this.$refs.tableData2.toggleRowSelection(item, true)
                        }
                    }
                });
                this.totalInfo.totalMoney = 0
                this.totalInfo.totalMoney = nvl.reduce((prev, item) => {
                    prev += +item.settleMoney || 0;
                    return prev;
                }, 0);
                this.totalInfo.totalMoney = NP.round(this.totalInfo.totalMoney, 2)
            },
            deep: true,
            immediate: true,
        },
        "totalInfo.selRadio": {
            handler: function (nvl, ovl) {
                // 付款/货款

                this.getDataList1()

            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: { isPenetrate }, //参数
                    },
                    "*"
                );
            }
        },
        settleMoneyJudge(row, index) {//付款

            // if (!this.isPositiveNumber(row.settleMoney)) {
            //     this.$set(this.tableData1[index], "settleMoney", '')
            //     this.$message.warning("请输入正确的金额")
            //     return
            // }
            if (row.settleMoney < 0) {
                this.$set(this.tableData1[index], "settleMoney", '')
                this.$message.warning("请检查金额")
                return
            }
            let rowSettleMoney = Math.abs(row.settleMoney)//输入
            let rowreturnSettlementBalance = Math.abs(row.settlementBalance) //可退
            console.log(row, rowSettleMoney, rowreturnSettlementBalance)
            if (rowSettleMoney > rowreturnSettlementBalance) {
                this.$set(this.tableData1[index], "settleMoney", row.settlementBalance)
                this.$message.warning("请检查金额")
            }
        },
        settleMoneyJudge1(row, index) {//货款
            // if (!this.isPositiveNumber(row.settleMoney)) {
            //     this.$set(this.tableData1[index], "settleMoney", '')
            //     this.$message.warning("请输入正确的金额")
            //     return
            // }
            if (row.settleMoney < 0) {
                this.$set(this.tableData1[index], "settleMoney", '')
                this.$message.warning("请检查金额")
                return
            }
            let rowSettleMoney = Math.abs(row.settleMoney)//输入
            let rowreturnSettlementBalance = Math.abs(row.oldBalance) //上期余额
            if (rowSettleMoney > rowreturnSettlementBalance) {
                this.$set(this.tableData1[index], "settleMoney", row.oldBalance)
                this.$message.warning("请检查金额")
            }
        },
        changeChoice(val) {
            console.log(val, "123123")
            this.multipleSelection = val;
            this.tableData1.forEach((item) => {
                this.multipleSelection.forEach((items) => {


                    if (this.totalInfo.selRadio == "付款") {
                        if (items.pprmId == item.pprmId && item.settleMoney == 0) {
                            console.log(this.multipleSelection)
                            item.settleMoney = item.settlementBalance;
                        }
                    }
                    else {
                        if (items.businessId == item.businessId && item.settleMoney == 0) {
                            item.settleMoney = item.oldBalance;
                        }

                    }

                });
            });
        },

        rowStyle({ row, rowIndex }) {
            if (row.settleMoney) {
                return {
                    'background-color': '#0089ff82',
                }
            } else {
                return {}
            }

        },
        async saveData() {
            this.totalInfo.totalMoney = this.tableData1.reduce(
                (prev, item) => {
                    prev += +item.settleMoney || 0;
                    return prev;
                },
                0
            );
            this.totalInfo.totalMoney = NP.round(this.totalInfo.totalMoney, 2)
            if (this.totalInfo.totalMoney > this.totalInfo.settleMoney) {
                return this.$message.error("结算总金额不能大于认款余额！");
            }
            if (this.tableData1.length == 0) {
                return this.$message.warning("请先选择数据");
            }
            let arr = []
            this.tableData1.forEach(item => {
                if (item.settleMoney > 0) {
                    arr.push({
                        "businessId": this.totalInfo.selRadio == '付款' ? item.pprmId : item.businessId,
                        "settleMoney": item.settleMoney,
                        "settlementBalance": item.settlementBalance
                    })
                }
            })
            let params = {
                "octid": this.tableData[this.leftSelectIndex].octId,
                "presettleDetailAdds": arr,
                "refundType": this.totalInfo.selRadio == '付款' ? 0 : 1,
                "settlementAllMoney": this.totalInfo.totalMoney
            }
            console.log(params)
            let res = await this.$http.registerAddRerurnPreSettle(params)
            if (res.status == 200) {
                this.$message({
                    message: res.message,
                    type: "success",
                });
                this.getDataList();
                this.leftSelectIndex = 0
                this.searchData1()
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                });
            }

            return

        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getExtractName(e) {
            console.log(e);
            this.exTitle = e;
        },
        openSearch({ sId, index, type, sField }) {
            this.seId = sId;
            this.sField = sField;
            this.DialogVisible = true;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        async seedetail(dasmId) {

            let responseData = await this.$http.acceptsettlementQueryPsaccountDetailList({
                ids: [
                    dasmId
                ],
            });
            if (responseData.status == 200) {
                this.detailData = responseData.result;
                this.showDetail = true;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        // 获取数据列表
        async getPageInfo() {



            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId],
            });
            this.addYuFukuanForm =
                responseData.result.jurFormVoList[0].jurconfigform;
            if (responseData.status == 200) {
                this.getButtonList();
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList;
                var obj = {};
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(
                        this.pageShowData.jurHead.jurconfigform,
                        "page",
                        "rows",
                        30
                    );
                } else {
                    obj = this.$common.getSearch(
                        this.getRequestData1,
                        "start",
                        "end",
                        "page",
                        "rows",
                        30
                    );
                }
                for (const key in obj) {
                    this.$set(this.getRequestData1, key, obj[key]);
                }
                this.getDataList();
                this.$http
                    .getJur({
                        ids: ["1613901622380"], //采购结算申请
                    })
                    .then((res) => {
                        this.addCaiGouForm =
                            res.result.jurFormVoList[0].jurconfigform;
                        this.newFormDataList = res.result.jurFormVoList;
                    });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
            this.showTable = true
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },
        // 数据搜索
        searchData1() {
            this.getRequestData1.page = 1;
            this.getRequestData1.coId = this.tableData[this.leftSelectIndex].coId || ""
            this.getRequestData1.smId = this.tableData[this.leftSelectIndex].cmId || ''
            this.getRequestData1.salesId =
                this.tableData[this.leftSelectIndex].salesId || ""
            this.getRequestData1.opmId =
                this.tableData[this.leftSelectIndex].opmId || ""
            this.getDataList1();
        },
        // 数据翻页
        setDataPageNumber1(val) {
            this.getRequestData1.page = val;
            this.getDataList1();
        },
        // 切换显示条数
        setDataPageSize1(val) {
            this.getRequestData1.page = 1;
            this.getRequestData1.rows = val;
            this.getDataList1();
        },
        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.acceptsettlementQueryReturnRkRecordList(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.tableData = this.$common.getIndex(responseData.result.list);
                this.total = responseData.result.total;
                this.totalInfo.settleMoney = this.tableData[0].unsettlement

                this.searchData1()
            } else {
                this.tableData = []
                this.total = 0
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getDataList1() {
            let responseData = ""
            if (this.totalInfo.selRadio == '付款') {
                responseData = await this.$http.registerQueryWaitPre(this.getRequestData1)
            } else {
                responseData = await this.$http.acceptsettlementQueryPsaccountList(
                    this.getRequestData1
                );
            }


            if (responseData.status == 200) {
                this.tableData1 = this.$common.getIndex(responseData.result.list.map(item => {
                    item.settleMoney = 0
                    return item
                }))
                this.total1 = responseData.result.total;
            } else {
                this.tableData1 = []
                this.total1 = 0
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
            if (this.totalInfo.selRadio == '付款') {
                this.$refs.tableData1.doLayout()
            } else {
                this.$refs.tableData2.doLayout()
            }
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
            
        },
//获取状态
        getIsGsp(str, val) {
            try {
                if (str.indexOf("[") === -1) return val;
                str && str.replace(/\\/g, "");
                let arr = JSON.parse(str);
                let len = arr.length;
                let newStr = "";
                for (let i = 0; i < len; i++) {
                    if (arr[i].key == val) {
                        newStr = arr[i].value;
                        break;
                    }
                }
                return newStr ? newStr : val;
            } catch (ex) {
                return val;
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {


        this.getPageInfo();

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    mounted() { },
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.$nextTick(() => {

            this.tableHeight =
                document.documentElement.querySelector(".page_content").clientHeight -
                document.documentElement.querySelector(".el-card__header")
                    .clientHeight -
                141;
            this.tableHeight1 =
                document.documentElement.querySelector(".page_content").clientHeight -
                document.documentElement.querySelector(".el-card__header")
                    .clientHeight -
                141;
        })
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.content {
    display: flex;
    justify-content: space-between;
}

.box-card {
    flex: 1;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
::v-deep .el-card .el-card__body {
    padding-top: 0;
}
::v-deep .el-card .el-card__header {
    padding-bottom: 10px;
}
</style>